import React, { useState } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import { Row, Col, Card, CardBody } from 'reactstrap';
import LoadingButton from '@mui/lab/LoadingButton';
import StatementAlert from './StatementAlert';
import { MaterialTable } from '@alumni-ventures-group/react-shared/lib/components';
import { uid } from 'react-uid';
import { downloadFileById } from '../../../../shared/services/apiGateway';
import sortByNumberValue from '../../helpers/sortByNumberValue';

const columnTitlesReports = [
  {
    alignment: 'left',
    id: 'reportName',
    label: 'Report Name',
  },
  {
    alignment: 'left',
    id: 'publicationDate',
    label: 'Publication Date',
  },
  {
    alignment: 'left',
    id: 'download',
    label: 'File',
  },
];

const FileDownloadButton = ({ fileId, currentManagedUserId }) => {
  const [isLoading, setLoading] = useState(false);

  const handleFileDownload = async () => {
    setLoading(true);
    const fileDownloadUrl = await downloadFileById(fileId, currentManagedUserId ? `?userid=${currentManagedUserId}` : '');
    if (fileDownloadUrl && fileDownloadUrl.fileUrl) window.open(fileDownloadUrl.fileUrl, '_blank');
    setLoading(false);
  };

  return (
    <LoadingButton
      type="button"
      variant="contained"
      loading={isLoading}
      onClick={() => handleFileDownload()}
    >
      View
    </LoadingButton>
  );
};

const returnReportsDataObject = (reports, currentUser, currentManagedUserId) =>
  reports.map((report) => {
    let name = report.fileName;
    if (report.documentType === 'Personal_Portfolio_Report' && currentUser) {
      name = `Personal Portfolio Report for ${currentUser.first_name || currentUser.firstName} ${
        currentUser.last_name || currentUser.lastName
      }`;
    } else if (report.documentType === 'User_Investment_Plan' && currentUser) {
      name = `Venture Plan for ${currentUser.first_name || currentUser.firstName} ${
        currentUser.last_name || currentUser.lastName
      }`;
    }
    return {
      reportName: name,
      publicationDate: moment(report.createdAt).format('MMMM DD, YYYY'),
      // eslint-disable-next-line max-len
      download: {
        renderCustomCell: () => <FileDownloadButton fileId={report.id} currentManagedUserId={currentManagedUserId} />,
      },
    };
  });

const VenturePlanningTable = ({ reports, currentUser, currentManagedUserId }) => (
  <Row key={uid('id')}>
    <Col>
      <Card style={{ paddingTop: '30px' }}>
        <CardBody
          style={{
            // boxShadow: 'rgba(0, 0, 0, 0.04) 0px 10px 36px 0px, rgba(0, 0, 0, 0.06) 0px 0px 0px 1px',
            padding: '8px, 10px',
          }}
        >
          <Row>
            <Col>
              <h4>Venture Planning</h4>
            </Col>
          </Row>
          <StatementAlert
            title={<>Your Personal Planning Reports</>}
            body={
              <>
                Thank you for your investment with Alumni Ventures. Below you will find your
                Personal Portfolio Report, which is a custom report just for your investments. We
                will automatically update this report every quarter.
                <br />
                <br />
                If you have submitted a venture plan, you will also find that report here. If not,
                you can do so using the "Planning" tab at the top of this page. Investors who submit
                a plan (non-binding) will be removed from fund marketing emails and instead start to
                receive 1x1 personalized support through our Account Management program.
              </>
            }
          />
          <Row>
            <Col>
              <MaterialTable
                columns={columnTitlesReports}
                dataArray={returnReportsDataObject(reports, currentUser, currentManagedUserId)}
                preSort={{ field: 'publicationDate', order: 'desc' }}
                edit={null}
                rowSize={25}
                selectable={false}
                showToolbar={false}
                wrapHeaders
                customSort={sortByNumberValue}
                hidePagination={true}
              />
            </Col>
          </Row>
        </CardBody>
      </Card>
    </Col>
  </Row>
);

VenturePlanningTable.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  reports: PropTypes.any.isRequired,
};

export default VenturePlanningTable;
